"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMELINE_REQUEST_EXAMPLE = exports.ADVANCED_SEARCH_REQUEST_EXAMPLE = exports.SEARCH_PATIENT_REQUEST_EXAMPLE = exports.timelineRequestSchema = exports.advancedSearchRequestSchema = exports.searchPatientRequestSchema = exports.patientSearchCriteriaSchema = void 0;
/**
 * `searchPatient`/`advancedSearch`/`timeline` — the 3 read-only
 * endpoints, mirroring `SearchApplicationService`'s query methods
 * exactly. `searchPatientRequestSchema`'s `criteria` matches
 * `PatientSearchCriteria` (`backend/src/modules/patient/patient/patient.repository.ts`,
 * frozen); wrapped in `SearchSpecificationRequest` (`../search`) for
 * the pagination/sort envelope every search endpoint shares.
 */
const zod_1 = require("zod");
exports.patientSearchCriteriaSchema = zod_1.z.object({
    uhid: zod_1.z.string().optional(),
    /**
     * Partial UHID — the register's own filter, as distinct from `uhid`'s exact
     * natural-key lookup. A clerk holding a card types the last few digits; an
     * exact-match-only filter answered that with an empty register.
     */
    uhidContains: zod_1.z.string().optional(),
    familyNameContains: zod_1.z.string().optional(),
    givenNameContains: zod_1.z.string().optional(),
    /** Guardian / next-of-kin name — `Patient.relationName`, a real column. */
    relationNameContains: zod_1.z.string().optional(),
    /** Matched against the patient's contact rows, partial and case-insensitive. */
    mobileContains: zod_1.z.string().optional(),
    dateOfBirth: zod_1.z.coerce.date().optional(),
    status: zod_1.z.enum(['ACTIVE', 'INACTIVE', 'MERGED', 'DECEASED', 'BLOCKED']).optional(),
    isUnknownIdentity: zod_1.z.boolean().optional(),
    primaryBranchId: zod_1.z.string().uuid().optional(),
    /**
     * Registration-date window on `Patient.createdAt`, half-open
     * `[registeredFrom, registeredTo)`. Additive and optional, so every
     * existing caller is unaffected.
     *
     * Pass `registeredTo` as the start of the day AFTER the intended range
     * — an inclusive end-of-day bound would otherwise drop anyone
     * registered between 00:00:00.001 and 23:59:59 on the last day.
     */
    registeredFrom: zod_1.z.coerce.date().optional(),
    registeredTo: zod_1.z.coerce.date().optional(),
    genderId: zod_1.z.string().uuid().optional(),
    uhidCounterType: zod_1.z.enum(['OPD', 'CR', 'CHILDREN']).optional(),
    registrationCompleteness: zod_1.z.enum(['MINIMAL', 'FULL']).optional(),
    isNewborn: zod_1.z.boolean().optional(),
});
exports.searchPatientRequestSchema = zod_1.z.object({
    criteria: exports.patientSearchCriteriaSchema,
    pagination: zod_1.z.object({ page: zod_1.z.number().int().positive(), limit: zod_1.z.number().int().positive().max(100) }),
    sort: zod_1.z.string().optional(),
});
exports.advancedSearchRequestSchema = zod_1.z.object({
    uhid: zod_1.z.string().optional(),
    contactValue: zod_1.z.string().optional(),
    givenName: zod_1.z.string().optional(),
    familyName: zod_1.z.string().optional(),
    /** Guardian/next-of-kin name (`Patient.relationName`) — e.g. finding a newborn/dependent by the parent's name. */
    relationName: zod_1.z.string().optional(),
    dateOfBirth: zod_1.z.coerce.date().optional(),
    // Enterprise Architecture Handbook v1.0, Part IV.3 (Search Configuration)
    // — additive, optional; wires up encrypted/hashed lookup infrastructure
    // that already existed but no search entry point called before this.
    governmentIdNumber: zod_1.z.string().optional(),
    abhaNumber: zod_1.z.string().optional(),
    policyNumber: zod_1.z.string().optional(),
    legacyMrNumber: zod_1.z.string().optional(),
});
exports.timelineRequestSchema = zod_1.z.object({
    patientId: zod_1.z.string().uuid(),
    limit: zod_1.z.number().int().positive().max(200).optional(),
});
exports.SEARCH_PATIENT_REQUEST_EXAMPLE = {
    criteria: { familyNameContains: 'Rao', status: 'ACTIVE' },
    pagination: { page: 1, limit: 20 },
    sort: 'familyName:asc',
};
exports.ADVANCED_SEARCH_REQUEST_EXAMPLE = {
    contactValue: '+919999999999',
};
exports.TIMELINE_REQUEST_EXAMPLE = {
    patientId: '22222222-2222-2222-2222-222222222222',
    limit: 50,
};
//# sourceMappingURL=search.request.js.map